import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
import { H4 } from 'foundations-components/transitional/components/H4';
import { H2 } from 'foundations-components/transitional/components/H2';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import FormattedMessage from 'I18n/components/FormattedMessage';
import StyledSection from '../publicLayout/components/StyledSection';
import { View } from 'foundations-components/transitional/components/View';
import { CapIcon, DealsIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Icon = ({
  icon
}) => /*#__PURE__*/_jsx(IconHolder, {
  color: "icon-core-subtle",
  icon: icon,
  padding: "0",
  size: "1000"
});
const columnWidth = 350;
const WhyGetCertifiedSection = () => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    as: "section",
    textAlign: "center",
    children: /*#__PURE__*/_jsx(StyledSection, {
      backgroundColor: "var(--trellis-color-fill-field-default)",
      children: /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
        children: [/*#__PURE__*/_jsx(H2, {
          marginBlockEnd: "300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.whyGetCertifiedSection.title"
          })
        }), /*#__PURE__*/_jsxs(TFlex, {
          gap: 30,
          justify: "around",
          wrap: isMobile ? 'wrap' : 'nowrap',
          children: [/*#__PURE__*/_jsxs(Box, {
            basis: columnWidth,
            children: [/*#__PURE__*/_jsx(Icon, {
              icon: CapIcon
            }), /*#__PURE__*/_jsx(H4, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.whyGetCertifiedSection.getEducated"
              })
            }), /*#__PURE__*/_jsx("p", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.whyGetCertifiedSection.getEducatedDescription"
              })
            })]
          }), /*#__PURE__*/_jsxs(Box, {
            basis: columnWidth,
            children: [/*#__PURE__*/_jsx(Icon, {
              icon: DealsIcon
            }), /*#__PURE__*/_jsx(H4, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.whyGetCertifiedSection.getRecognized"
              })
            }), /*#__PURE__*/_jsx("p", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.whyGetCertifiedSection.getRecognizedDescription"
              })
            })]
          })]
        })]
      })
    })
  });
};
export default WhyGetCertifiedSection;